import styled from 'styled-components';
import { Row } from 'antd';

export const StyledRow = styled(Row)`
    gap: 12px;
`;
